import { FunctionalComponent, h } from '@stencil/core';

const iconTemplate: HTMLTemplateElement = document.createElement('template');
iconTemplate.innerHTML = `<span class="external-icon">&nbsp;<hp6-icon name="system-link-external" size-selection="xs"></hp6-icon></span>`;

/**
 * @description External link icon
 */
const ExternalIcon: FunctionalComponent = () => (
  <span class="external-icon">
    &nbsp;
    <hp6-icon name="system-link-external" size-selection="xs" />
  </span>
);

export default ExternalIcon;
export { iconTemplate };
